export default {
  data() {
    return {}
  },
  methods: {
    toTop(domId = '') {
      let top = 0
      var timer = setInterval(function() {
        if (domId) {
          // offsetTop 相对于其 offsetParent 元素的顶部内边距的距
          top = document.getElementById(domId).offsetTop + 138
          console.log(top)
        }
        const osTop = document.documentElement.scrollTop || document.body.scrollTop
        const ispeed = Math.floor(-osTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed
        if (osTop <= top) {
          clearInterval(timer)
        }
      }, 30)
    }
  }
}
